import {QUERY_KEY_TASKS_SINGLE_VOYAGES} from "@containers/singleVoyage/tasks/queryHooks/constants/queryKey";
import {queryClient} from "@app/appProvider/queryClient/queryClient";

export const refetchTasksSingleVoyage = () => {
    queryClient.invalidateQueries({queryKey: [QUERY_KEY_TASKS_SINGLE_VOYAGES]});
}
